<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.19995 14.4001L12 9.6001L16.8 14.4001" stroke="white" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
